/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleCustomState.js'
import mutations from './moduleCustomMutations.js'
import actions from './moduleCustomActions.js'
import getters from './moduleCustomGetters.js'

export default {
		namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
